<template>
  <div data-page='1' class="home page">
    <section class="hero-content fill-height">
         <swiper :option="swiperOption" class="swipe-container">
           <swiper-slide>
             <div class="page-media">
               <vue-plyr class="embed-container">
                <div class="plyr__video-embed">
                  <iframe
                    src="https://www.youtube.com/embed/DAwJ0JAMIt0"
                    allow="autoplay"
                    allowfullscreen
                    allowtransparency
                  ></iframe>
                </div>
              </vue-plyr>
             </div>
           </swiper-slide>
           <swiper-slide>
             <div class="page-media">
             <vue-plyr class="embed-container">
                <div class="plyr__video-embed">
                  <iframe
                    src="https://www.youtube.com/embed/DAwJ0JAMIt0"
                    allow="autoplay"
                    allowfullscreen
                    allowtransparency
                  ></iframe>
                </div>
              </vue-plyr>
             </div>
           </swiper-slide>
                   <!-- Add Pagination -->
            <div class="swiper-pagination"></div>
                   <!-- Add Arrows -->
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
         </swiper>
    </section>
  </div>
</template>

<script>
  import UiModal from '@/components/UiModal.vue'
  import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'
  import UiInputText from '@/components/UiInputText.vue'
  import UiCheckbox from '@/components/UiCheckbox.vue'
  import UiPaginationOffset from '../components/UiPaginationOffset'
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'

  export default {
    name: 'IndexPage',

    components: {
      UiModal,
      UiBaseIcon,
      UiInputText,
      UiCheckbox,
      UiPaginationOffset,
      swiper,
      swiperSlide
    },

    data () {
      return {
        title: null,
        headline: null,
        bgTxt: null,
        isShownModal: false,
        inputError: false,
        checkboxState: false,

        pagination: {
          limit: 20,
          offset: 0,
          total: 60
        },

        swiperOption: {
          loop: true,
          centerSlides: true,
          grabCursor: true,
          watchSlidesProgress:true,
          pagination:{
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        }
      }
    },

    methods: {
      showToast () {
        console.log('aaa')
        this.$store.commit('toast/NEW', {type: 'success', message: 'hello'})
      },
      submitModalHandler () {
        // some logic
        this.isShownModal = false
      },
      onBlur () {
        console.log('onBlur!!!')
      },
      onEnter () {
        console.log('onEnter!!!')
      },
      onEsc () {
        console.log('onEsc!!!')
      },
      onClickIcon () {
        console.log('onClickIcon!!!!')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .homes {
    background-image: linear-gradient(
        135deg,
        rgba($mel-blue,1) 0%,
        rgba($mel-blue-darker,1) 25%,
        rgba($mel-purple,1) 51%,
        rgba($mel-purple-darker,1) 100%
    );
  }

  .some-modal-content {
    min-width: 400px;
    padding: 25px;

    .buttons button {
      padding: 10px;
      margin: 10px;
    }
  }

  .page-body {
    top: 20%;
  }

  .home .page-media {
    max-width: 960px;
    margin: 0 auto;
    text-align: center;

    @include media_tablet {
      transform: translateY(75%);
    }
  }

  .embed-container {
    position: relative;
    overflow: hidden;
    width: 100%;
    margin-top: 100px;
    height: auto;
    box-shadow: 0 2.5em 2.5em -1.875em rgba(0, 0, 0, .5),
    0 1.25em 5em 1em rgba(0, 0, 0, .2);
    border-radius: 6px;
  }

  .swiper-container {
    @include media_tablet {
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue